import { render, staticRenderFns } from "./Identity.vue?vue&type=template&id=1f8e7a0c&scoped=true&"
import script from "./Identity.vue?vue&type=script&lang=js&"
export * from "./Identity.vue?vue&type=script&lang=js&"
import style0 from "./Identity.vue?vue&type=style&index=0&id=1f8e7a0c&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f8e7a0c",
  null
  
)

export default component.exports